import { useNavigate } from "react-router-dom";
import "./ProjectsCard.scss";

export function ProjectsCard({ project, offlineMode }) {
  const navigate = useNavigate();

  return (
    <div className="project-card ">
      <ul>
        <li
         onClick={() =>
            navigate(
              `/projects/projectsDetails?employer=${project.employer}&projectId=${project.id}&offlineMode=${offlineMode}`
            )
          }
          className="mb-3 mt-2"
        >کارفرما: {project.employer}</li>
        <li>
          {/* <a href={`tel:${project.phone_number}}`} > شماره تماس: {project.phone_number}</a> */}
          <a href={`tel:${project.phone_number}}`}>
            شماره تماس: {project.phone_number}
          </a>
        </li>
        <li>
          {project.location ? (
            <a
              href={`https://maps.google.com/?q=${project.location?.replaceAll(
                " ",
                ""
              )}`}
            >
              آدرس: {project.address}
            </a>
          ) : (
            <>آدرس: {project.address}</>
          )}
        </li>
      </ul>
    </div>
  );
}
export default ProjectsCard;
